module.exports = __webpack_public_path__ + "static/media/principles-of-econ-completed.3bd6edf9.svg";